module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-plus-3f735305.svg";